import React, { useEffect, useState, useContext } from "react";
import { strings, translate } from "./../../services/Localization";
import { checkLogin } from "./../../services/Login";
import { dialog, dialogDescription } from '../../components/Common';
import { useNavigate, useParams  } from 'react-router-dom';
import { appBaseUrl, getAppBase, getLabelBasedOnServerType, UUIDCOLWIDTH } from '../../utils/consts';
import { faPlay, faStop, faAdd, faGear, faRefresh  } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { IUser } from "src/dassTypes";
import AppContext from '../../context/AppContext'
import { BreadCrumbType, PageButtonType } from '../../datatypes/datatypes';
import { ActionType, BulkActionType, ColumnType, DataTableOption } from '../../components/Common/DataTable/DataTypes';
import { GenericDassQuery } from "../../services/BasicDassQueries";
import { toast } from "./../../utils/Toaster";
import { TAB_ADD_APP, TAB_EDIT_APP, TAB_EDIT_DEFAULT_PUSH_CONFIG } from '../../datatypes/tabsconstants'
import{ APP_ACC_GROUP_ID_INPUT_VALIDATION, DEFAULT_RECORD_LIMIT, ID_INPUT_VALIDATION }  from "../../components/Common/DataTable/DataTableConsts";
import PageContent from "../PageContent";
import { getVisibleActions, actionIcon, prioritizedTableColumns } from "./../../utils/filters";
import { isMobile } from "react-device-detect";


declare const constants;

export interface IRowType {
    accountid: string;
    app_uuid: string;
    enabled: boolean;
}

interface IMyAppsStates {
    loggedUser: IUser | null;
    showAlertModal: boolean;
    pageTitle: string;
    editEntityId: string | null;            // The entity in this view is a group
    schemaMethod: '' | "post" | "put" | string;
    breadCrumbArr: BreadCrumbType[];
    refresh:boolean;
    globalPushStatus: boolean; // This is change the State of Default Push Button
    isRowDeleted?:boolean;
}


const MyApps: React.FC<{}> = () => {

    const AppContextObj = useContext(AppContext);

    const isDmp = constants?.server_type === "dmp";
    const isOrbiwan = !isDmp;

    const canDelete = () => ((isOrbiwan && (AppContextObj?.user?.can_register || AppContextObj?.user?.can_control_devices)) ||
                             (isDmp     &&  AppContextObj?.user?.can_delete_applications)) && !AppContextObj?.user?._readonly;
    const canUpdate = () => ((isOrbiwan && (AppContextObj?.user?.can_register || AppContextObj?.user?.can_control_devices)) ||
                             (isDmp     &&  AppContextObj?.user?.can_update_applications)) && !AppContextObj?.user?._readonly;
    const canCreate = () => ((isOrbiwan && (AppContextObj?.user?.can_register || AppContextObj?.user?.can_control_devices)) ||
                             (isDmp     &&  AppContextObj?.user?.can_create_applications)) && !AppContextObj?.user?._readonly;


    

    const stateInit = {
        loggedUser: AppContextObj.user,
        showAlertModal: false,
        pageTitle: strings.NAV_USERS_ITEM,
        editEntityId: '',
        schemaMethod: '',
        breadCrumbArr: [getLabelBasedOnServerType(strings.NAV_DEVICE_MANAGEMENT, strings.NAV_APPLICATION, ''), {label:strings.NAV_APPLICATIONS_ITEM,url:''}],
        refresh:false,
        globalPushStatus: false,
        isRowDeleted:false
    };

    const [state, setState] = useState<IMyAppsStates>(stateInit)
    
    const navigate = useNavigate();

    let { id, tabname } = useParams();

    useEffect(() => {

        let globalPushStatus 

        async function init ()  {
            const pushStatus = await GenericDassQuery("/rest/pushmode/status", { method: "GET"})
            if(pushStatus.status === 200 && pushStatus.data) {
                globalPushStatus = pushStatus.data.enabled
                setState(prevState => { return {...prevState, loggedUser: AppContextObj.user, globalPushStatus: globalPushStatus }})
            }
        } 

        if (constants.enable_profiles !== true) {
            window.location.href = appBaseUrl ;
            
        } else {
            
            if(checkLogin(AppContextObj.user)) {    
                init()
            }
        }

    },[AppContextObj.user?.userid])


    const defaultStartStopGlobalPush = async ( ) => {
        try {
            
            if(state.globalPushStatus === true) {
                const data = await GenericDassQuery("/rest/pushmode/stop", { method: "PUT", data: { enabled: false} })
                if(data.status === 200) {
                    setState(prevState => { return {...prevState, globalPushStatus: false }})
                }
                toast.success(strings.STOP_APPLICATION_PUSH_SUCCESS);
            } else {
                const globalPushdata = await GenericDassQuery("/rest/pushmode/status", { method: "GET"});
                const data = await GenericDassQuery("/rest/pushmode/start", { method: "PUT", data: globalPushdata.data })
                if(data.status === 200) {
                    setState(prevState => { return {...prevState, globalPushStatus: true }})
                }
                toast.success(strings.START_APPLICATION_PUSH_SUCCESS);
            }
        } catch (e) {
            toast.error(e.message);
        }
    }


    const deleteApp = async ( app: IRowType ) => {

        const confirmDialogeSettings = {
            title:  strings.DELETE_APPLICATION_CONFIRMATION,
            description: `${strings.DELETE} "${app.accountid}"'?`,
            actionLabel: strings.ACTION_DELETE,
        };

        if (await dialog(confirmDialogeSettings) === true) {
            // spinnerClass.show();
            try {
                await GenericDassQuery("/rest/applications/" + app.accountid, { method: "DELETE" });
                refreshTable(true);
                toast.success(strings.DELETE_APPLICATION_SUCCESS);
            } catch (e) {
                toast.error(e.message);
            }
            // spinnerClass.hide();
        }

    }

    const startPush = async ( app: IRowType ) => {
        try {
            await GenericDassQuery("/rest/applications/" + app.accountid, { method: "PUT", data: { enabled: true }});
            refreshTable();
            toast.success(strings.START_APPLICATION_PUSH_SUCCESS);
        } catch (e) {
            toast.error(e.message);
        }
    }


    const stopPush = async (app: IRowType) => {
        try {
            await GenericDassQuery("/rest/applications/" + app.accountid, { method: "PUT", data: { enabled: false }});
            refreshTable();
            toast.success(strings.STOP_APPLICATION_PUSH_SUCCESS);
        } catch (e) {
            toast.error(e.message);
        }
    }
    
    const batchAppDelete = async ( selectedIds ) => {

        const accountIds = selectedIds.map((row) => {
            return row['accountid'];
        })
        if(accountIds && accountIds.length > 0) {
            const confirmDialogeSettings = {
                title:  translate(strings.BULK_APPLICATION_DELETE_CONFIRMATION, {count: accountIds.length}) as string,
                description: await dialogDescription(accountIds) + "",
                actionLabel: strings.ACTION_DELETE,
            };
    
            if (await dialog(confirmDialogeSettings) === true) {
                try {
                    Promise.all(accountIds.map((accountId) => {
                        return GenericDassQuery("/rest/applications/" + accountId, { method: "DELETE" });
                    })).then((values) => {
                        refreshTable(true);
                        toast.success(strings.BULK_APPLICATION_DELETE_SUCCESS);
                    }).catch((e) => {
                        toast.error(e.message);
                    });
                } catch (e) {
                    toast.error(e.message);
                }       
            }
        }
    }

    const batchAppStartPush =  async ( selectedIds ) => {

        const accountIds = selectedIds.map((row) => {
            return row['accountid'];
        })
        if(accountIds && accountIds.length > 0) {
            const confirmDialogeSettings = {
                title:  strings.BULK_START_APPLICATION_PUSH_CONFIRMATION,
                description:'',
                actionLabel: strings.BULK_START_APPLICATION_LABEL,
            };
            if (await dialog(confirmDialogeSettings) === true) {
                try {
                    Promise.all(accountIds.map((accountId) => {
                        return GenericDassQuery("/rest/applications/" + accountId, { method: "PUT" , data: {enabled: true}});
                    })).then((values) => {
                        refreshTable();
                        toast.success(strings.BULK_START_APPLICATION_PUSH_SUCCESS);  
                    }).catch((e) => {
                        toast.error(e.message);
                    });
                } catch (e) {
                    toast.error(e.message);
                }       
            }
        }
    }


    const batchAppStopPush = async ( selectedIds ) => {

        const accountIds = selectedIds.map((row) => {
            return row['accountid'];
        })
        if(accountIds && accountIds.length > 0) {
            const confirmDialogeSettings = {
                title:  strings.BULK_STOP_APPLICATION_PUSH_CONFIRMATION,
                description:'',
                actionLabel: strings.BULK_STOP_APPLICATION_LABEL,
            };
            if (await dialog(confirmDialogeSettings) === true) {
                try {
                    Promise.all(accountIds.map((accountId) => {
                        return GenericDassQuery("/rest/applications/" + accountId, { method: "PUT" , data: {enabled: false}});
                    })).then((values) => {
                        refreshTable();
                        toast.success(strings.BULK_STOP_APPLICATION_PUSH_SUCCESS);
                    }).catch((e) => {
                        toast.error(e.message);
                    });
                } catch (e) {
                    toast.error(e.message);
                }       
            }
        }
    }

    

    const addAppDialog = ( navigate, tab ) => {
        const prevPageUrl = `${getAppBase()}/my-apps`;
        navigate(`${getAppBase()}/my-apps/${tab}`, {state: {tab: tab, prevPageUrl: prevPageUrl}})
    }

    const editGlobalPush = ( navigate, tab ) => {
        const prevPageUrl = `${getAppBase()}/my-apps`;
        navigate(`${getAppBase()}/my-apps/edit/${tab}`, {state: {tab: tab, prevPageUrl: prevPageUrl}})
    }
    

    const getActions = () => {
        
        let actions:ActionType<IRowType>[] = [
            {
                type: "action",
                text: strings.HTTP_PUSH_START,
                render: (row, title) => actionIcon(row.accountid, title, faPlay.iconName),
                action: (app) => startPush(app)	,
                visible: (app) => (app?.enabled === false && canUpdate())
            },{
                type: "action",
                text: strings.HTTP_PUSH_STOP,
                render: (row, title) => actionIcon(row.accountid, title, faStop.iconName),
                action: (app) => stopPush(app),
                visible: (app) => (app?.enabled === true && canUpdate())
            }, {
                type: "action",
                text: strings.MY_APPS_ACTION_DELETE,
                render: (row, title) => actionIcon(row.accountid, title, faTrashAlt.iconName),
                action: (app) => deleteApp(app),
                visible: (app) => canDelete()
            }
        ];

        let bulkActions:BulkActionType<IRowType>[] = [
        {
            type: "action",
            text: strings.MY_APPS_ACTION_BULK_DELETE,
            render: (row, title) => actionIcon(row.accountid, title, faTrashAlt.iconName),
            action: ( selectedIds ) => { batchAppDelete(selectedIds) },
            visible: () => canDelete()
        },
        {
            type: "action",
            text: strings.HTTP_PUSH_START,
            render: (row, title) => actionIcon(row.accountid, title, faPlay.iconName),
            action: ( selectedIds ) => { batchAppStartPush(selectedIds) },
            visible: (app) => (app?.enabled === false && canUpdate())
        },{
            type: "action",
            text: strings.HTTP_PUSH_STOP,
            render: (row, title) => actionIcon(row.accountid, title, faStop.iconName),
            action: ( selectedIds ) => { batchAppStopPush(selectedIds) },
            visible: (app) => (app?.enabled === false && canUpdate())
        }];

        return {
            actions: actions,
            bulkActions:bulkActions
        }
    }

    
    const detailPageNav = ( navigate, tab, accountId, row) => {

        const prevPageUrl = `${getAppBase()}/my-apps`;

        navigate(`${getAppBase()}/my-apps/${accountId}/${TAB_EDIT_APP}`, {state: {row: row, prevPageUrl:prevPageUrl}})

    }

    

    const  initDataTable = () => {

        const {actions, bulkActions} = getActions();

		let columns: ColumnType<IRowType>[] = [
            {
                key: 'bulk_action_checkbox',
                type: "bulk_action_checkbox",
                title: 'Bulk Action',
                filterable: false,
                cellWidth: 3,
                newCellWidth: '30px',
                customClass: 'sticky left-first',
            },
            {
                key: "app_uuid",
                type: "text",
                title: strings.UUID,
                render_tooltip: (row) => row.app_uuid,
                render: (row) => row.app_uuid ,
                dataAlign: "left",
                filterable: true,
                filterField: 'search_uuid',
                filterType: 'text',
                inputValidation: ID_INPUT_VALIDATION,
                copyLink: true,
                customClass: 'font-monospace nowarp fa-80 left',
                newCellWidth: (isMobile ? UUIDCOLWIDTH : '90px'),
                cellWidth:100,
                cellWidthType:'%',
                width: 310,
                minWidth : 90,
                maxWidth: 310,
                resizable: true,
                showCopyLink: true,
            },
            {
                key: "accountid",
                type: "text",
                title: strings.APP_ID,
                filterable: true,
                inputValidation: APP_ACC_GROUP_ID_INPUT_VALIDATION,
                filterType: 'text',
                filterField: 'search_id',
                filterParams: {
                    mapper: (x) => x || undefined
                },
                detailLink: true,
                detailPageNav: (row) =>  detailPageNav(navigate, TAB_EDIT_APP, row.accountid, row ),
                customClass: 'nowarp',
                cellWidth: 25,
                newCellWidth: isMobile ? '250px' : '30%',
                width: 250,
                minWidth: 250,
                resizable: true,
                showCopyLink: true,
            }, 
            {
                key: "description",
                title: "Description",
                type: "text",
                filterable: true,
                inputValidation: ID_INPUT_VALIDATION,
                filterType: 'text',
                filterField: 'search_description',
                cellWidth: 30,
                newCellWidth: "45%",
                width: 100,
                minWidth: 100,
                flex: 2,
                resizable: true,
                showCopyLink: true,
            },  
            {
                key: "enabled",
                title: strings.STATUS,
                type: "icon_with_tooltip",
                render_icon: (obj) => obj.enabled ? faPlay : faStop,
                render_tooltip: (obj) => { return obj.enabled ? 'started' : 'stopped' },
                filterable: false,
                cellWidth: 6,
                newCellWidth: "10%",
                dataAlign:'center',
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                flex: 1,
                resizable: false,
                hideDefaultTooltip: true
            }
        ];

        columns.push({
                key: 'action_button',
                type: "action_button",
                title: 'Actions',
                filterable: false,
                cellWidth: 3,
                newCellWidth: "140px",
                customClass: 'sticky right',
            });
            
        if(isMobile) prioritizedTableColumns(['bulk_action_checkbox', 'accountid'], columns)
        
        
        const options: DataTableOption<IRowType> = {
            url:'/uiapi/rest/applications',
            query_param:{all:true, get_pages:true, limit:DEFAULT_RECORD_LIMIT, stream:'progress'},
            serial_number:false,
            id_field:'accountid',
            oboe_path:'pages.*',
            available_key: 'accountid',
            emptyDataMsg: strings.NO_APPLICATION_AVAILABLE,
            columns,
            actions: actions,
            bulkActions: getVisibleActions(bulkActions),
            agGridAdjustWidthKeys: ['description'],
        }
        return options;
	}

    const refreshTable = (isRowDeleted = false) => {

        setState(prevState => {
            return {...prevState, refresh:!prevState.refresh, isRowDeleted: isRowDeleted}
        })
        
    }

    
    
    const getPageButtons = () => {
        const pageButtons: PageButtonType[] = [
            {
                title: strings.REFRESH_LIST,
                action: () => { refreshTable() },
                type: 'button',
                icon: faRefresh
            },
            {
                title: strings.EDIT_GLOBAL_PUSH_CONFIG,
                action: () => editGlobalPush(navigate, TAB_EDIT_DEFAULT_PUSH_CONFIG),
                type: 'button',
                icon: faGear,
                visible: () => { return canUpdate() }
            },
            {
                title: 'separator',
                type: 'separator',
            },
            {
                title: state.globalPushStatus ? strings.MY_APPS_STOP_DEFAULT_PUSH : strings.MY_APPS_START_DEFAULT_PUSH,
                action: () => defaultStartStopGlobalPush(),
                type: 'button_with_icon',
                icon:  state.globalPushStatus ? faStop : faPlay,
                visible: () => { return canUpdate() }
            },
            {
                title: 'separator',
                type: 'separator',
            },
            {
                title: strings.MY_APPS_APP,
                action: () => addAppDialog(navigate, TAB_ADD_APP),
                type: 'button_with_icon',
                icon: faAdd,
                visible: () => { return canCreate() }
            },
        ]

        return pageButtons;
    }

    return (
        <PageContent
            name="my-apps" 
            id={id} 
            tabname={tabname} 
            actions={getActions()} 
            breadCrumbArr={state.breadCrumbArr} 
            pageButtons={getPageButtons()} 
            countLabel={`Applications`} 
            dataTableOption={initDataTable()} 
            isRowDeleted={state.isRowDeleted}
            refresh={state.refresh}>
        </PageContent>
    );
}


export default MyApps;